import { apiClient } from "features/shared/api/axiosInstance";
import type { MintPointsRequest } from "common/models/api/models/MintPointsRequest";
import type { OrganizationPointDto } from "common/models/api/models/OrganizationPointDto";
import type { PointDto } from "common/models/api/models/PointDto";
import type { RevertTransactionRequest } from "common/models/api/models/RevertTransactionRequest";
import type { SendPointsFromResourceRequest } from "common/models/api/models/SendPointsFromResourceRequest";

export const pointsApi = {
    findBy: (organizationAddress: string) => apiClient.get<OrganizationPointDto>("/api/points/findBy", { params: { organizationAddress } }),

    findByTokenAddress: (tokenAddress: string) => apiClient.get<PointDto>(`/api/points/${tokenAddress}`),

    mint: (body: MintPointsRequest) => apiClient.post("/api/points/mint", body),

    getBalance: (address: string) => apiClient.get<string>(`/api/points/balance/${address}`),

    sendFromResource: (body: SendPointsFromResourceRequest) => apiClient.post<string>("/api/points/send-resource", body),

    revertTransaction: (body: RevertTransactionRequest) => apiClient.post("/api/points/revert-transaction", body),

    updateConversionRate: (tokenAddress: string, body: { conversionRate: number }) =>
        apiClient.put(`/api/points/${tokenAddress}/conversion-rate`, body),

    updateCaducity: (body: { caducityDays: number }) => apiClient.put("/api/points/modify-caducity", body),
};
